import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const TABS = [
  { key: "activity", href: "/chantiers/dashboard",     icon: "chart-column" },
  { key: "hours",    href: "/projects/hours_tracking", icon: "stopwatch" },
]

const DashboardTabs = ({ active }) => (
  <nav className="inline-flex items-center gap-1 rounded-md bg-slate-100 p-1 text-[13px] font-medium">
    {TABS.map(tab => (
      <a
        key       = {tab.key}
        href      = {tab.href}
        className = {`h-7 px-3 inline-flex items-center gap-1.5 rounded transition-colors ${
          tab.key === active ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"
        }`}
      >
        <FontAwesomeIcon icon={tab.icon} className="w-3 h-3" />
        {I18n.t(`chantiers_dashboard.tabs.${tab.key}`)}
      </a>
    ))}
  </nav>
)

export default DashboardTabs
